import React from 'react';
import { Modal, ModalHeader, ModalBody, ModalFooter, Button, Card, CardBody, Badge } from 'reactstrap';
import { H6, P } from '../../../../AbstractElements';

const QuestionViewModal = ({ isOpen, toggle, quiz }) => {
  if (!quiz) return null;
  

  return (
    <Modal isOpen={isOpen} toggle={toggle} size="lg">
      <ModalHeader toggle={toggle}>
        Câu hỏi: {quiz.name}
      </ModalHeader>
      <ModalBody style={{maxHeight: '60vh', overflowY: 'auto'}}>
        {quiz.questions && quiz.questions.length > 0 ? (
          quiz.questions.map((question, qIndex) => (
            <Card key={qIndex} className="mb-3 border">
              <CardBody className="p-3">
                <div className="d-flex align-items-center gap-2 mb-2">
                  <Badge color="primary">Câu {qIndex + 1}</Badge>
                  <Badge color={question.type === 'single' ? 'info' : 'warning'}>
                    {question.type === 'single' ? 'Single Choice' : 'Multiple Choice'}
                  </Badge>
                </div>
                
                <P className="text-dark mb-3">
                  <strong>{question.content?.text || question.content}</strong>
                </P>

                <div className="ps-3">
                  {question.answers && question.answers.map((answer, aIndex) => (
                    <div key={aIndex} className="d-flex align-items-center mb-2">
                      <div className="me-2" style={{width: '24px'}}>
                        {answer.isCorrect ? (
                          <i className="fa fa-check-circle text-success"></i>
                        ) : (
                          <i className="fa fa-circle-o text-muted"></i>
                        )}
                      </div>
                      <span className={answer.isCorrect ? 'text-success fw-medium' : 'text-dark'}>
                        {String.fromCharCode(65 + aIndex)}. {answer.content}
                      </span>
                    </div>
                  ))}
                </div>
              </CardBody>
            </Card>
          ))
        ) : (
          <div className="text-center py-5">
            <i className="fa fa-question-circle text-muted" style={{fontSize: '3rem'}}></i>
            <p className="text-muted mt-3">Chưa có câu hỏi nào</p>
          </div>
        )}

        {/* Quiz Info */}
        <Card className="bg-light border-0">
          <CardBody className="p-3">
            <div className="d-flex justify-content-between">
              <small className="text-muted">
                <strong>Tổng câu hỏi:</strong> {quiz.totalQuestions || 0}
              </small>
              <small className="text-muted">
                <strong>Hiển thị:</strong> {quiz.displayQuestions || 0} câu
              </small>
            </div>
          </CardBody>
        </Card>
      </ModalBody>
      <ModalFooter>
        <Button color="secondary" onClick={toggle}>
          Đóng
        </Button>
      </ModalFooter>
    </Modal>
  );
};

export default QuestionViewModal;

